import { IBaseVraagboomResultaat } from './base.vraagboom.resultaat';

export class VraagboomTimeResultaat implements IBaseVraagboomResultaat {
  minuten: number;
  uren: number;

  public get tijd() {
    return this.pad(this.uren) + ':' + this.pad(this.minuten);
  }

  constructor(uren: number, minuten: number) {
    this.minuten = minuten;
    this.uren = uren;
  }

  private pad(x: number): string {
    return ((('' + x).length == 2) ? '' : '0') + x;
  }
}
